import { render, staticRenderFns } from "./termsForm.vue?vue&type=template&id=20532159&"
import script from "./termsForm.vue?vue&type=script&lang=js&"
export * from "./termsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports